import { pushNotificationActions } from "../../actionTypes";

const initialState = {
	notifiableUsers: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case pushNotificationActions.FETCH_NOTIFIABLE_USERS: {
			return { ...initialState, fetching: true };
		}

		case pushNotificationActions.FETCH_NOTIFIABLE_USERS_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				notifiableUsers: action.payload,
			};
		}

		case pushNotificationActions.FETCH_NOTIFIABLE_USERS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
